<template>
<div class="work" id="work-3">
	<h2><span>06</span>e-Supri</h2>
	<div class="subtitle">
		<h3><span>Year</span>2018</h3>
		<h3><span>Product</span>Integrated Platform</h3>
		<h3><span>Technology</span>Webservice App</h3>
	</div>
	<blockquote>
		E-supri is a platform for e-commerce B2B for support of the network of suppliers and logistics for Fast-food restaurants. In Brazil, it helps big global franchises like Burger King, Taco Bell, Pizza Hut and local franchises like Mundo Verde, etc.
	</blockquote>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>The main goal for this project is to fulfill the necessity of receiving all the request from the restaurant networks. This is done by the store owners that have a lot of tech restrictions like low internet speed, old screens with low resolution and also add new tasks for the store owner wasn't trained.</p>
			<h3>My Role</h3>
			<p>My role in this project was to redesign the dynamic and flow of the platform, the interface design, the front-end development in HTML/CSS and the interactions in Jquery.  </p>
		</figcaption>
		<span><img src="../../assets/desk_esupri-0.jpg" alt="e-Supri"></span>
		<span><img src="../../assets/desk_esupri-1.jpg" alt="e-Supri"></span>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>The main interface was simplified with only a main screen with the last request and a menu with 3 buttons ( 5 for the admin access), focusing on being more optimization to the main goal, making it more intuitive enough for the first contact with the interface states clear for the user what it's his/her goals on it. Also, there's always the same grid, with a list of information to the left,  a box with the details in the right and the filters int the top menu.</p>
			<p>The product list was a key point of attention to be really clear for the order requests. So, in the counterhand of other e-commerce B2C, it's not necessary to make an extended evaluation of the products and the acquisition of one by one, as the store owner knows his/her needs for the store. For the user, it's just required to fill the quantity of each product, supported by filters. For this step, there are only two simple confirmation screens to avoid mistakes and the user is able to make a efficient revision of what was requested.</p>
		</figcaption>
		<img src="../../assets/mob_esupri.jpg" alt="e-Supri mobile">
		<img src="../../assets/mob_esupri-1.jpg" alt="e-Supri mobile">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>The information relies a lot on the memory of the store owner about the store need so the development needed to be fully responsive to be efficient in mobile devices that are used in storages.</blockquote> 
		</figcaption>
		<img src="../../assets/mob_esupri-2.jpg" alt="e-Supri mobile">
	</figure>
	<figure>
		<span><img src="../../assets/desk_esupri-2.jpg" alt="e-Supri"></span>
	</figure>
	<blockquote>
		"The challenge in the development and project solutions was the needs for both parts, the administrators and the customers, it has restrict access in the site but can be visited in <a href="//www.esupri.com.br" target="_blank">www.esupri.com.br</a>"
	</blockquote>
</div>
</template>